<template>
  <v-container fluid class="pa-0 ma-8">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="groups"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-3 rounded-lg"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>المجموعات</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogGroup
            :item="item"
            :saveFunction="save"
            mode="add"
            iconName="mdi-plus"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogGroup
            :item="item"
            :saveFunction="save"
            mode="edit"
            iconName="mdi-pencil"
          />

          <DialogSimp
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :item="item"
            :confirmFunction="deleteItem"
            :message="messages.delete"
          />

          <!-- <DialogSimp
            v-if="item.status == 'blocked'"
            :v-model="dialogSimp"
            iconName="mdi-check-all"
            :item="item"
            :confirmFunction="activateItem"
            :message="messages.activate"
          />
          <DialogSimp
            v-if="item.status == 'active'"
            :v-model="dialogSimp"
            iconName="mdi-check"
            :item="item"
            :confirmFunction="deactivateItem"
            :message="messages.deactivate"
          /> -->
        </v-row>
      </template>
      <template v-slot:[`item.isNoCut`]="{ item }">
        <v-container>
          <p>{{ item.isNoCut ? $t("yes") : $t("no") }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.isDiscount`]="{ item }">
        <v-container>
          <p>{{ item.isDiscount ? $t("yes") : $t("no") }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.discount`]="{ item }">
        <v-container>
          <p>
            {{ item.discount }}{{ item.discountType == "fixed" ? "" : "%" }}
          </p>
        </v-container>
      </template>
      <template v-slot:[`item.discountType`]="{ item }">
        <v-container>
          <p>{{ $t(`${item.discountType}`) }}</p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import DialogGroup from "@/components/dialogs/DialogGroup.vue";
import DialogSimp from "@/components/DialogSimp.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogGroup,
    DialogSimp,
    OverlayLoader,
  },
  data: () => ({
    loading: false,
    headers: [
      { title: "الاسم", key: "name" },
      { title: "الوصف", key: "description" },
      { title: "معفى من القطع", key: "isNoCut" },
      { title: "له خصم", key: "isDiscount" },
      { title: "قيمة الخصم", key: "discount" },
      { title: "نوع الخصم", key: "discountType" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
  }),
  computed: {
    groups() {
      let us = repo.groups.getAllGroups();
      return us;
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await repo.groups.fetchAll();
      if (res) {
        //swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async save(formData, mode) {
      formData.isNoCut = formData.isNoCut ? 1 : 0;
      formData.isDiscount = formData.isDiscount ? 1 : 0;

      if (mode == "add") {
        console.log("form", mode, formData);
        const res = await repo.groups.add(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      } else {
        console.log("form", mode, formData);

        const res = await repo.groups.update(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      }
    },
    async deleteItem(item) {
      const res = await repo.groups.delete(item.id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      //console.log("item to delete:", item.id);
    },
    activateItem(item) {
      console.log("item to activate:", item);
    },
    deactivateItem(item) {
      console.log("item to deactivate:", item);
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
